import styled from 'styled-components';

export const UploadList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
`;

export const UploadListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
`;

export const UploadItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme?.colors?.textMuted || '#64748b'};
  flex-shrink: 0;
`;

export const UploadItemName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: ${({ theme }) => theme?.colors?.text || '#1e293b'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UploadItemStatus = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
  white-space: nowrap;
`;
